<template>
  <ul
      v-if="subList != 'undefined'"
      role="list"
      class="mt-2 space-y-2 text-sm"
  >
    <li
        class="text-black text-sm"
        v-for="(subDetail, subDetailIdx) in subList"
        :key="subDetailIdx"
    >
      <p v-if="subDetail.title !== '' && subDetail.value != ''" class="text-gray-600">
        <span class="text-brand-main pr-2">{{ subDetail.title }}:</span>

        <template v-if="subDetail.parameter == 'stone_certificate'">
          <a
              v-if="subDetail.value.includes('GIA')"
              href="/diamanten/gia_zertifikat"
              target="_blank"
              class="text-black underline"
          >{{ $t(pageStr + '.gemological_certificate') }}</a>
          <a
              v-else-if="subDetail.value.includes('IGI')"
              href="/diamanten/im_labor_hergestellte_diamanten#facts"
              target="_blank"
              class="text-black underline"
          >{{ $t(pageStr + '.gemological_certificate') }}</a>
          <template v-else>{{ subDetail.value }}</template>
        </template>
        <template v-else>
          {{ subDetail.value }}
        </template>
      </p>
      <description-parts-sub :sub-list="subDetail.sub"/>
    </li>
  </ul>
</template>
<script setup lang="ts">
import {defineProps} from "vue";

defineProps(["subList"]);

const pageStr = "components.description.descriptionPartsSub"
</script>
